<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="payApply">去设置</el-button>
    </settings-card>
    <product-group-modal
      ref="group"
      :applyInfo="userDetail" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import SettingsCard from './settings-card.vue'
import ProductGroupModal from './product-group-modal.vue'
export default {
  name: 'ProductGroup',
  components: {
    SettingsCard,
    ProductGroupModal
  },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    payApply() {
      this.$refs.group.getsetting()
    }
  }
}
</script>
